<template>
    <div class="container-fluid">
        <b-overlay :show="showOverlay" rounded="sm">
            <grid
                controllers='true' 
                :titles='titles'
                :data='stock'
                current-sort="id"
                :search-key="search"
                @clicked="onClickEvent"
            />
        </b-overlay>
    </div>
</template>
<script>
    import grid from '@/components/grid.vue'
    export default {
        name: 'vwProdutos',
        components: {
            grid
        },
        data() {
            return {
                showOverlay: false,
                titles: ['CODIGO', 'PRODUTO', 'FORNECEDOR', 'FABRICA', 'CEST', 'UNIDADE', 'ESTOQUE', 'VALOR'],
                stock: [],
                search: 'DESCRICAO',
                searching: 0
            }
        },
        computed: {
            getToken(){
                return this.$store.getters.getToken
            }
        },
        methods: {
            getData: function(){
                this.showOverlay = true
                // eslint-disable-next-line
                fetch(server + 'crud/produtos/', {
                    method: 'GET',
                    headers: new Headers({
                        'token' : this.getToken
                    })
                })
                    .then(response => (response.json()))
                    .then(responseJSON => {
                        if(responseJSON.data == true){
                            this.stock = responseJSON.response
                        }
                    })
                    .catch(error => {
                        console.log('Error exception', '=>', error)
                    })
                    .finally(() => {
                        this.showOverlay = false
                    })
            },

            onClickEvent: function(value){
                this.$router.push({
                    name: 'produtos.editar',
                    params: {
                        id: value.id
                    }
                })
            }
        },
        mounted(){
            this.getData()
        }
    }
</script>
<style scoped>

</style>